export interface SOP {
  id: number; // SOP任务ID
  corpId: string; // 企业ID
  userId: string; // 员工ID、群主ID
  shopId: string; // 店铺ID
  journeyId: number; // 旅程ID
  journeyNodeId: number; // 旅程节点ID
  sopId: number; // sopId
  sopContentId: number; // SOP内容节点ID
  sopName: string; // sop名称
  scene: string; // 场景：客户旅程名称-节点名称
  sendTime: string; // 发送时间
  executeTime: string; //执行时间
  sopSendType: SOPSendType; // SOP触达方式：消息(每日)、消息(每周)
  totalAmount: number; // 目标客户数（总客户数）
  sendAmount?: number; // 已发送客户数
  hasSend?: boolean; // 是否发送
  status?: SOPStatus; // 任务状态
  entityType?: SOPType; // 实体类型
  messageContent?: { type: MessageType; content: MessageContent }[];
  executionResult?: ExecutionResult;
}

export interface MessageContent {
  text: string;
  title: string;
  picUrl: string;
  desc: string;
  url: string;
  actId: string;
  name: string;
  appId: string;
  page: string;
}

export interface ExecutionResult {
  id: number; // SOP任务ID
  status: string; // 任务状态：待完成、已完成
  sendType: string; // 发送方式：快捷发送、一键发送
  hasSendAmount: number; // 已发送客户数
  successAmount: number; // 发送成功客户数
  failureAmount: number; // 发送失败客户数
  sendTime: string; // 发送时间
}

export enum MessageType {
  TEXT = 1,
  IMAGE = 2,
  LINK = 3,
  WEAPP = 4,
  ACTIVITY = 5,
}

export enum SOPType {
  CUSTOMER_SOP = "CUSTOMER_SOP", // 客户SOP
  CHAT_SOP = "CHAT_SOP", // 客户群SOP
}

export enum SOPStatus {
  PENDING = "PENDING", // 待完成
  COMPLETE = "COMPLETE", // 已完成
}

export enum SOPSendType {
  DAY = "DAY",
  WEEK = "WEEK",
}

export const sopTypeList = [
  { key: SOPType.CUSTOMER_SOP, title: "客户", dataKey: "customer" },
  { key: SOPType.CHAT_SOP, title: "群", dataKey: "chat" },
];

export const sopStatusList = [
  { key: SOPStatus.PENDING, title: "待完成", dataKey: "pending" },
  { key: SOPStatus.COMPLETE, title: "已完成", dataKey: "complete" },
];

export const COMPLETE_MARKER = "执行完消息发送操作后，需手动标记完成";
